import { EditUnitFormType, EditUnitOptions } from '@mark43/cad-api';
import { useWatch } from 'react-hook-form';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { FormSelect } from '../../forms/integrated-form-controls/form-select';

export function VehicleSelect({
    formFieldOptions,
    isVehicleRequired,
}: {
    formFieldOptions: EditUnitOptions;
    isVehicleRequired?: boolean;
}): React.ReactElement {
    const { form } = useIntegratedForm<EditUnitFormType>();
    const callSignValue = useWatch({ control: form.control, name: 'callSign' });
    const showAsRequired = !!isVehicleRequired && !!callSignValue;

    return (
        <FormSelect
            name="vehicleTag"
            control={form.control}
            label="Vehicle"
            isDisabled={!callSignValue}
            options={formFieldOptions.vehicleTagOptions}
            showRequiredIndicator={showAsRequired}
            rules={{
                validate: (fieldValue) => (showAsRequired && !fieldValue ? 'Required' : true),
            }}
        />
    );
}
